<template>
  <div class="p-20">
    <van-form ref="form" :show-error="false" error-message-align="right">
      <div class="font-32 font-weight-500 cor-00 m-t-16 m-b-26">基本信息</div>
      <van-cell-group>
        <van-field v-f-show="'ssbm'" input-align="right" name="ssbm" :required="isRequired('ssbm')"
                   :value="formData.ssbm" label="部门" :rules="getRules('ssbm')" placeholder="请选择部门">
          <template #input>
            <view-item @click.native="isShowPopup(ssbm,'ssbm')" :value="formData.ssbm" placeholder="请选择部门"/>
            <van-popup v-model="ssbm.show" position="bottom">
              <van-nav-bar title="选择部门" left-text="取消" right-text="确定" @click-left="ssbm.show = false"
                           @click-right="popupSubmit('ssbm',{label:'label',value:'value'})"/>
              <van-search v-model="ssbm.filterText" @input="pickerSearch($event,ssbm,'label')" clearable shape="round"/>
              <van-picker ref="ssbm" value-key="label" :columns="ssbm.filteredData" @cancel="ssbm.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'htmc'" v-model="formData.htmc" :required="isRequired('htmc')" :rules="getRules('htmc')"
                   name="htmc" label="合同名称" placeholder="请输入合同名称" input-align="right">
          <template #input>
            <view-item @click.native="isShowPopup(htmc,'htmc')" :value="formData.htmc" placeholder="请选择合同名称"/>
          </template>
        </van-field>
        <van-field v-f-show="'khmc'" v-model="formData.khmc" :disabled="isDisabled('khmc')"
                   :required="isRequired('khmc')" :rules="getRules('khmc')" name="khmc" maxlength="50" autosize
                   label="客户名称" placeholder="请输入客户名称" input-align="right"/>
        <!--        <van-field v-f-show="'ssxm'" v-model="formData.ssxm" :required="isRequired('ssxm')" :rules="getRules('ssxm')" name="ssxm" label="所属项目" placeholder="请输入所属项目" input-align="right">-->
        <!--          <template #input>-->
        <!--            <view-item :value="formData.ssxm" placeholder="选择合同后自动带出所属项目"/>-->
        <!--          </template>-->
        <!--        </van-field>-->
        <van-field v-f-show="'htje'" :disabled="isDisabled('htje')" v-model="formData.htje" type="number" name="htje"
                   :rules="getRules('htje')" :required="isRequired('htje')" :maxlength="10" placeholder="请输入合同金额"
                   label="合同金额" input-align="right" @change="formatToTwoDecimals(formData, 'htje')"></van-field>
        <van-field v-f-show="'htje'" v-model="formData.htje" label="" input-align="right" readonly>
          <template #input>
            <div>
              <span v-text="getFormatValue(formData.htje)+' 元'" v-if="formData.htje && formData.htje!=0"></span>
              <span v-else>无</span>
              <span class="p-l-20" v-if="formData.htje && formData.htje!=0"> 大写：</span>
              <span class="cor-F64646" v-if="formData.htje && formData.htje != 0">{{ getChinese(formData.htje) }}</span>
            </div>
          </template>
        </van-field>
        <van-field v-f-show="'ykpje'" :disabled="isDisabled('ykpje')" v-model="formData.ykpje" type="number"
                   name="ykpje" :rules="getRules('ykpje')" :required="isRequired('ykpje')" :maxlength="10"
                   placeholder="请输入已开票金额" label="已开票金额" input-align="right"
                   @change="formatToTwoDecimals(formData, 'ykpje')"></van-field>
        <van-field v-f-show="'ykpje'" v-model="formData.ykpje" label="" input-align="right" readonly>
          <template #input>
            <div>
              <span v-text="getFormatValue(formData.ykpje)+' 元'" v-if="formData.ykpje && formData.ykpje!=0"></span>
              <span v-else>无</span>
              <span class="p-l-20" v-if="formData.ykpje && formData.ykpje!=0"> 大写：</span>
              <span class="cor-F64646" v-if="formData.ykpje && formData.ykpje != 0">{{
                  getChinese(formData.ykpje)
                }}</span>
            </div>
          </template>
        </van-field>
        <van-field v-f-show="'kpje'" :disabled="isDisabled('kpje')" v-model="formData.kpje" type="number" name="kpje"
                   :rules="getRules('kpje')" :required="isRequired('kpje')" :maxlength="10" placeholder="请输入开票金额"
                   label="开票金额" input-align="right" @change="formatToTwoDecimals(formData, 'kpje')"></van-field>
        <van-field v-f-show="'kpje'" v-model="formData.kpje" label="" input-align="right" readonly>
          <template #input>
            <div>
              <span v-text="getFormatValue(formData.kpje)+' 元'" v-if="formData.kpje && formData.kpje!=0"></span>
              <span v-else>无</span>
              <span class="p-l-20" v-if="formData.kpje && formData.kpje!=0"> 大写：</span>
              <span class="cor-F64646" v-if="formData.kpje && formData.kpje != 0">{{ getChinese(formData.kpje) }}</span>
            </div>
          </template>
        </van-field>
        <van-field v-f-show="'kplx'" input-align="right" name="kplx" :required="isRequired('kplx')"
                   :rules="getRules('kplx')" :value="formData.kplx" label="开票类型" placeholder="请选择开票类型">
          <template #input>
            <view-item @click.native="isShowPopup(kplx,'kplx')" :value="formData.kplx" placeholder="请选择开票类型"/>
            <van-popup v-model="kplx.show" position="bottom">
              <van-nav-bar title="选择开票类型" left-text="取消" right-text="确定" @click-left="kplx.show = false"
                           @click-right="popupSubmit('kplx')"/>
              <van-search v-model="kplx.filterText" @input="pickerSearch($event,kplx)" clearable shape="round"/>
              <van-picker ref="kplx" :columns="kplx.filteredData" @cancel="kplx.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'kprq'" v-model="formData.kprq" :required="isRequired('kprq')" name="kprq" label="开票日期"
                   placeholder="开票日期" input-align="right" :rules="getRules('kprq')">
          <template #input>
            <view-item @click.native="isShowPopup(kprq,'kprq')" :value="formData.kprq" placeholder="请选择开票日期"/>
            <van-calendar v-model="kprq.show" :min-date="minDate" ref="kprq" :show-confirm="false"
                          title="选择开票日期"
                          @confirm="kprqConfirm"></van-calendar>
          </template>
        </van-field>
        <van-field v-f-show="'fpkjdw'" input-align="right" name="fpkjdw" :required="isRequired('fpkjdw')"
                   :value="formData.fpkjdw" label="开具单位" :rules="getRules('fpkjdw')" placeholder="请选择开具单位">
          <template #input>
            <view-item @click.native="isShowPopup(fpkjdw,'fpkjdw')" :value="formData.fpkjdw"
                       placeholder="请选择开具单位"/>
            <van-popup v-model="fpkjdw.show" position="bottom">
              <van-nav-bar title="选择开具单位" left-text="取消" right-text="确定" @click-left="fpkjdw.show = false"
                           @click-right="popupSubmit('fpkjdw',{label:'label',value:'value'})"/>
              <van-search v-model="fpkjdw.filterText" @input="pickerSearch($event,fpkjdw,'label')" clearable
                          shape="round"/>
              <van-picker ref="fpkjdw" value-key="label" :columns="fpkjdw.filteredData" @cancel="fpkjdw.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <!--        <van-field v-f-show="'kjnr'" input-align="right" name="kjnr" :required="isRequired('kjnr')"-->
        <!--                   :rules="getRules('kjnr')" :value="formData.kjnr" label="开具内容" placeholder="请选择开具内容">-->
        <!--          <template #input>-->
        <!--            <view-item @click.native="isShowPopup(kjnr,'kjnr')" :value="formData.kjnr" placeholder="请选择开具内容"/>-->
        <!--            <van-popup v-model="kjnr.show" position="bottom">-->
        <!--              <van-nav-bar title="选择开具内容" left-text="取消" right-text="确定" @click-left="kjnr.show = false"-->
        <!--                           @click-right="popupSubmit('kjnr')"/>-->
        <!--              <van-search v-model="kjnr.filterText" @input="pickerSearch($event,kjnr)" clearable shape="round"/>-->
        <!--              <van-picker ref="kjnr" :columns="kjnr.filteredData" @cancel="kjnr.show = false"/>-->
        <!--            </van-popup>-->
        <!--          </template>-->
        <!--        </van-field>-->

<!--        <van-field v-f-show="'kjnr'" v-model="formData.kjnr" :disabled="isDisabled('kjnr')"-->
<!--                   :required="isRequired('kjnr')" :rules="getRules('kjnr')" name="kjnr" maxlength="100" autosize-->
<!--                   label="开具内容" placeholder="请输入开具内容" input-align="right"/>-->
<!--        <van-tag v-if="!isDisabled('kjnr')" @click="kjnrTabClick(item)" v-for="(item,index) in kjnr.filteredData"-->
<!--                 :key="index"-->
<!--                 class="m-l-20">-->
<!--          {{ item }}-->
<!--        </van-tag>-->
        <van-field v-f-show="'bz'" v-model="formData.bz" :disabled="isDisabled('bz')" :required="isRequired('bz')"
                   :rules="getRules('bz')" name="bz" type="textarea" maxlength="100" rows="3" autosize label="说明"
                   show-word-limit placeholder="标记需要注意的事项" input-align="right"/>
        <van-field v-f-show="'fpbz'" v-model="formData.fpbz" :disabled="isDisabled('fpbz')"
                   :required="isRequired('fpbz')" :rules="getRules('fpbz')" name="fpbz" type="textarea" maxlength="200"
                   rows="3" autosize label="发票备注" show-word-limit placeholder="这里填写需要在发票备注填写的内容"
                   input-align="right"/>
      </van-cell-group>

      <div class="font-32 font-weight-500 cor-00 m-t-16 m-b-26">开票信息</div>
      <van-cell-group v-for="(item,index) in formData.kpxxb" :key="index" class="b-r-10 m-t-20">
        <div style="border-bottom: 1px solid #EBEBEB" class="p-b-20">
          <van-row type="flex" align="center" class="flex col-center">
            <van-col :span="15">
              <img class="w-5 h-28" :src="`${image_base_url}/icon_line.png`">
              <span class="cor-33 font-weight-500 font-28 m-l-16">{{ `开票信息${index + 1}` }}</span>
            </van-col>
            <van-col :span="7">
              <van-button size="small" type="primary" @click.native="popupShow(kjnr.show, index,'itemName')" native-type="button">选择开具内容</van-button>
            </van-col>
            <van-col v-if="isShowIcon('kpxxb')" @click="removeItem(index,'kpxxb')" :span="2" class="m-t-14">
              <img class="w-30 h-30" :src="`${image_base_url}/shoppingDel.png`">
            </van-col>
          </van-row>
        </div>
        <van-popup v-model="kjnr.show[index]" position="bottom">
          <van-nav-bar title="选择开具内容" left-text="取消" right-text="确定" @click-left="popupHidden(kjnr.show,index)"
                       @click-right="kjnrSubmit(item, index)"/>
          <van-search v-model="kjnr.filterText" @input="pickerSearch($event,kjnr)" clearable shape="round"/>
          <van-picker :ref="`kjnrPicker_${index}`" value-key="name" :columns="kjnr.filteredData" @cancel="kjnr.show = false"/>
        </van-popup>

        <van-field v-f-show="'itemName'" v-model="item.itemName" :disabled="isDisabled('itemName')"
                   :required="isRequired('itemName')" :rules="getRules('itemName')" name="itemName" maxlength="50" autosize
                   label="开具内容" placeholder="请输入开具内容" input-align="right" />
        <van-field v-f-show="'specifications'" v-model="item.specifications" :disabled="isDisabled('specifications')"
                   :required="isRequired('specifications')" :rules="getRules('specifications')" name="specifications" maxlength="10" autosize
                   label="规格型号" :placeholder="isDisabled('num') ? '' : '请输入规格型号'" input-align="right"/>
        <van-field v-f-show="'unit'" v-model="item.unit" :disabled="isDisabled('unit')"
                   :required="isRequired('unit')" :rules="getRules('unit')" name="unit" maxlength="10" autosize
                   label="单位" :placeholder="isDisabled('unit') ? '' : '请输入单位'" input-align="right"/>
        <van-field v-f-show="'num'" v-model="item.num" :disabled="isDisabled('num')" type="number"
                   :rules="getRules('num')" :required="isRequired('num')" name="num"
                   maxlength="100" autosize label="数量" :placeholder="isDisabled('num') ? '' : '请输入数量'" input-align="right"
                   @change="formatToTwoDecimals(item, 'num')"
                   @blur="calculateAmount(item)" />
        <van-field v-f-show="'price'" v-model="item.price" :disabled="isDisabled('price')" type="number"
                   :rules="getRules('price')" :required="isRequired('price')" name="price"
                   autosize label="含税单价(元)" placeholder="请输入单价" input-align="right"
                   @change="formatToTwoDecimals(item, 'price')"
                   @blur="calculateAmount(item)" />
        <van-field v-f-show="'amount'" v-model="item.amount" :disabled="isDisabled('amount')" type="number"
                   :rules="getRules('amount')" :required="isRequired('amount')" name="amount"
                   autosize label="含税金额(元)" placeholder="请输入金额" input-align="right" @change="formatToTwoDecimals(item, 'amount')" @blur="calculateTotalAmount()"/>
      </van-cell-group>
      <van-field v-show="formData.totalAmount" v-model="formData.totalAmount" label="" input-align="right" readonly>
        <template #input>
          <div>
            <span v-text="getFormatValue(formData.totalAmount)+' 元'" v-if="formData.totalAmount && formData.totalAmount!=0"></span>
            <span v-else>无</span>
            <span class="p-l-20" v-if="formData.totalAmount && formData.totalAmount!=0"> 大写：</span>
            <span class="cor-F64646" v-if="formData.totalAmount && formData.totalAmount != 0">{{ getChinese(formData.totalAmount) }}</span>
          </div>
        </template>
      </van-field>
      <van-row v-if="!isDisabled('kpxxb')">
        <van-col :span="12"></van-col>
        <van-col :span="12">
          <van-button icon="add-o" round native-type="button" color="#FFDA3E" text="添加开票信息" @click="addKpItem"
                      class="width-100"/>
        </van-col>
      </van-row>

      <div class="font-32 font-weight-500 cor-00 m-t-16 m-b-26">客户发票信息</div>
      <van-cell-group>
        <van-field v-f-show="'ttlx'" input-align="right" name="ttlx" :required="isRequired('ttlx')"
                   :rules="getRules('ttlx')" :value="formData.ttlx" label="抬头类型" placeholder="请选择抬头类型">
          <template #input>
            <view-item @click.native="isShowPopup(ttlx,'ttlx')" :value="formData.ttlx" placeholder="请选择抬头类型"/>
            <van-popup v-model="ttlx.show" position="bottom">
              <van-nav-bar title="选择抬头类型" left-text="取消" right-text="确定" @click-left="ttlx.show = false"
                           @click-right="popupSubmit('ttlx')"/>
              <van-search v-model="ttlx.filterText" @input="pickerSearch($event,ttlx)" clearable shape="round"/>
              <van-picker ref="ttlx" :columns="ttlx.filteredData" @cancel="ttlx.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'kptt'" v-model="formData.kptt" :disabled="isDisabled('kptt')"
                   :required="isRequired('kptt')" :rules="getRules('kptt')" name="kptt" maxlength="100" autosize
                   label="开票抬头" placeholder="请输入开票抬头" input-align="right"/>
        <van-field v-f-show="'nsrsbh'" v-model="formData.nsrsbh" :disabled="isDisabled('nsrsbh')"
                   :required="isRequired('nsrsbh')" :rules="getRules('nsrsbh')" name="nsrsbh" maxlength="100" autosize
                   label="纳税人识别号" placeholder="请输入纳税人识别号" input-align="right"/>
        <van-field v-f-show="'khh'" v-model="formData.khh" :disabled="isDisabled('khh')"
                   :rules="getRules('khh')" :required="isRequired('khh')" name="khh"
                   maxlength="100" autosize label="开户行" placeholder="请输入开户行" input-align="right"/>
        <van-field v-f-show="'khzh'" v-model="formData.khzh" :disabled="isDisabled('khzh')"
                   :rules="getRules('khzh')" :required="isRequired('khzh')" name="khzh"
                   maxlength="100" autosize label="开户账号" placeholder="请输入开户账号" input-align="right"/>
        <van-field v-f-show="'fpjffs'" input-align="right" name="fpjffs" :required="isRequired('fpjffs')"
                   :rules="getRules('fpjffs')" :value="formData.fpjffs" label="发票交付方式"
                   placeholder="请选择发票交付方式">
          <template #input>
            <view-item @click.native="isShowPopup(fpjffs,'fpjffs')" :value="formData.fpjffs"
                       placeholder="请选择发票交付方式"/>
            <van-popup v-model="fpjffs.show" position="bottom">
              <van-nav-bar title="选择发票交付方式" left-text="取消" right-text="确定" @click-left="fpjffs.show = false"
                           @click-right="popupSubmit('fpjffs')"/>
              <van-search v-model="fpjffs.filterText" @input="pickerSearch($event,fpjffs)" clearable shape="round"/>
              <van-picker ref="fpjffs" :columns="fpjffs.filteredData" @cancel="fpjffs.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'kpdz'" v-model="formData.kpdz" :disabled="isDisabled('kpdz')"
                   :required="isRequired('kpdz')" :rules="getRules('kpdz')" name="kpdz" type="textarea" maxlength="200"
                   rows="3" autosize label="开票地址" show-word-limit placeholder="请输入开票地址" input-align="right"/>
        <van-field v-f-show="'dh'" :disabled="isDisabled('dh')" v-model="formData.dh" type="number" name="dh"
                   :rules="getRules('dh')" :required="isRequired('dh')" :maxlength="20" placeholder="请输入电话"
                   label="电话" input-align="right"></van-field>
        <van-field v-f-show="'fj'"  class="fileValueBox"  :value.prop="formData.fj" input-align="right" name="fj" :required="isRequired('fj')"
                   :rules="getRules('fj')" label="附件" placeholder="请上传文件">
          <template #input>
            <uploadFiles :disabled="isDisabled('fj')" :files="formData.fj" @success="uploadSuccess"
                         module-type="flow"   @fileRemove="(removedFile)=>handleFileRemove(removedFile,'formData','fj')"></uploadFiles>
          </template>
        </van-field>
      </van-cell-group>
        <div v-if="formData.fpjffs=='邮寄'" class="font-32 font-weight-500 cor-00 m-t-16 m-b-26">邮寄信息</div>
      <van-cell-group v-if="formData.fpjffs=='邮寄'">
        <van-field v-f-show="'lxr'" v-model="formData.lxr" :disabled="isDisabled('lxr')"
                   :required="!isDisabled('lxr') "   :rules="[{ required:!isDisabled('lxr') , message: '请输入联系人' }]" name="lxr" maxlength="20" 
                   label="联系人" placeholder="请输入联系人" input-align="right"/>     
        <van-field v-f-show="'lxfs'" :disabled="isDisabled('lxfs')" v-model="formData.lxfs" type="number" name="lxfs"
                   :rules="[{ required: !isDisabled('lxfs'), message: '请输入联系方式' }]" :required="!isDisabled('lxfs')" :maxlength="20" placeholder="请输入联系方式"
                   label="联系方式" input-align="right"></van-field>
          <van-field v-f-show="'yjdz'" v-model="formData.yjdz" :disabled="isDisabled('yjdz')"
                   :required="!isDisabled('yjdz')"  :rules="[{ required: !isDisabled('yjdz'), message: '请输入邮寄地址' }]" name="yjdz" type="textarea" maxlength="200"
                   rows="3" autosize label="邮寄地址" show-word-limit placeholder="请输入邮寄地址" input-align="right"/>
          <van-field v-f-show="'xxdz'" v-model="formData.xxdz" :disabled="isDisabled('xxdz')"
                   :required="!isDisabled('xxdz')"   :rules="[{ required: !isDisabled('xxdz'), message: '请输入详细地址' }]" name="xxdz" type="textarea" maxlength="200"
                   rows="3" autosize label="详细地址" show-word-limit placeholder="请输入详细地址" input-align="right"/>
      </van-cell-group>    

    </van-form>
    <div class="font-32 font-weight-500 cor-00 m-t-26">流程</div>
    <!--      这个是不带选人的流程图    -->
    <flowTrace v-if="!$route.query.reSend && (processInstanceId || $route.query.processInstanceId)" class="m-t-20"
               :flowTraceList="flowTrace" :processInfo="processData"></flowTrace>
    <!--      这个是带选人的流程图    -->
    <approver v-else class="m-t-20" ref="approver" @addUser="addUser" :processData="processData" :formData="formData"
              :formItemMap="formItemMap"/>
    <bottom-bar @submit="submit" @mention="mention"></bottom-bar>
    <van-popup position="bottom" v-model="approver.show">
      <van-nav-bar title="选择办理人" left-text="取消" right-text="确定" @click-left="approver.show = false"
                   @click-right="approverPopupSubmit"/>
      <van-search v-model="approver.filterText" @input="treeSearch($event, $refs.approverTree)" clearable
                  shape="round"/>
      <div style="overflow-y: auto" class="h-vh-35">
        <div class="p-10">
          <el-tree ref="approverTree" @check-change="approverCheckChange($event, $refs.approverTree)" node-key="uuid"
                   check-strictly :data="approver.data" :filter-node-method="filterNode" check-on-click-node
                   show-checkbox/>
        </div>
      </div>
    </van-popup>
    <contract :show="htmc.show" @finish="contractFinish" @close="htmc.show = false"></contract>
  </div>
</template>
<script>
import {getCurrentUserDept, getDeptUserTreeAll, selectMyProjectList} from '@/api/user.js'
import {fmInvoiceList, getFormDataByInstanceId, getInvoiceAmount} from "@/api/flow";
import cache from "@/plugins/cache";
import mixin from '@/mixin/flow'
import moment from "moment";
import {getDictDataByType} from "@/api/dict";
import uploadFiles from "@/components/uploadFiles/index.vue";
import fileMixins from "@/components/uploadFiles/fileMixins";
import bottomBar from '@/components/flow/bottom-bar.vue'
import flowTrace from '@/components/flow/flowTrace.vue'
import approver from "@/components/flow/approver.vue";
import account from '@/views/tripReimbursement/components/account.vue'
import contract from './components/contract.vue'
import {formatToTwoDecimals} from "@/utils/ruoyi";
const kpItem = {
  itemName: '',
  specifications: '',
  unit: '',
  num: '',
  price: '',
  amount: '',
}

export default {
  mixins: [mixin,fileMixins],
  components: {account, approver, bottomBar, flowTrace, uploadFiles, contract},
  watch: {
    'formData.kpxxb': {
      handler(newVal) {
        newVal.forEach((item, index) => {
          if (item.num && item.price) {
            const amount = parseFloat(item.num) * parseFloat(item.price);
            // 保留两位小数
            item.amount = amount.toFixed(2);
          }
        });
      },
      deep: true
    }
  },
  data() {
    return {
      minDate: new Date(2024, 0, 1),
      formData: {
        // 报销明细 默认自带一条数据
        kpxxb: [{
          itemName: '',
          specifications: '',
          unit: '',
          num: '',
          price: '',
          amount: '',
        }],
        flowNo: "",
        sqr: "",
        ssbm: "",
        ssxm: "",
        khmc: "",
        htmc: "",
        xmmc: "",
        htje: '',
        ykpje: '',
        kpje: '',
        kplx: "",
        kprq: "",
        kjnr: "",
        fpkjdw: "",
        ttlx: "",
        kptt: "",
        nsrsbh: "",
        khh: "",
        khzh: "",
        fpjffs: "",
        kpdz: "",
        dh: "",
        lxr: "",
        lxfs: "",
        yjdz: "",
        xxdz: "",
        fpbh: "",
        fj: [],
        htbh: '',
        qdrq: "",
        totalAmount:0
      },
      rules: {},
      htmc: {
        show: false
      },
      // 所属部门
      ssbm: {
        data: [],
        filteredData: [],
        filterText: '',
        show: false
      },
      // 选人树
      approver: {
        data: [],
        filterText: '',
        show: false
      },
      // 部门用户树
      deptUserTreeAll: {
        data: [],
        filterText: '',
        show: false
      },
      kprq: {
        show: false
      },
      // 所属项目
      ssxm: {
        data: [],
        show: false,
        filteredData: [],
        filterText: '',
      },
      // 开票抬头
      ttlx: {
        data: [],
        show: false,
        filteredData: [],
        filterText: '',
      },
      // 开票类型
      kplx: {
        data: [],
        show: false,
        filteredData: [],
        filterText: '',
      },
      // 发票交付方式
      fpjffs: {
        data: [],
        show: false,
        filteredData: [],
        filterText: '',
      },
      // 开具内容
      kjnr: {
        data: [],
        show: [],
        filteredData: [],
        filterText: '',
      },
      // 发票开开具单位
      fpkjdw: {
        data: [],
        show: false,
        filteredData: [],
        filterText: '',
      },
      formItemMap: null, // 表单字段的Map
    }
  },
  created() {
    const {templateId, groupId, reSend} = this.$route.query
    this.SET_TEMPLATE_ID(templateId)
    this.SET_GROUP_ID(groupId)
    this.init()
    if (reSend && this.$route.query.processInstanceId) { // 重新发起时
      this.$loading.show()
      this.getFormInfo({templateId: this.templateId}).then(res => {
        this.formItemMap = new Map(res.data?.currentNode?.props?.formPerms.map(item => [item.id, item]))
        // 从后台去流程表单数据 只取fomData
        getFormDataByInstanceId(this.$route.query.processInstanceId).then(form => {
          // 合并
          Object.assign(this.formData, res.data.processTemplates.expressVals, form.data)
          const contractId = this.formData.htmc.split(',')[0]
          getInvoiceAmount({contractId}).then(res => {
            this.formData.ykpje = res.data
          })
          this.$loading.hide()
        })
      })
    } else if (this.$route.query.processInstanceId && !this.$route.query.reSend) { // 外部跳转时
      this.SET_PROCESS_INSTANCE_ID(this.$route.query.processInstanceId)
      if (this.$route.query.taskId) {
        this.SET_TASK_ID(this.$route.query.taskId)
      }
      this.$loading.show()
      this.getProcessInfo({
        processInstanceId: this.$route.query.processInstanceId,
        taskId: this.$route.query.taskId
      }).then(res => {
        Object.assign(this.formData, res.data.formData)
        this.$loading.hide()
      })
    } else { // 新增时
      // 新增时调用
      this.getFormInfo({templateId: this.templateId, groupId: this.groupId}).then(res => {
        this.formItemMap = new Map(res.data?.currentNode?.props?.formPerms.map(item => [item.id, item]))
        Object.assign(this.formData, res.data.processTemplates.expressVals)
      })
      // 新增时 初始化的时候预定人是当前登录用户
      const currentUserInfo = JSON.parse(cache.session.get("userInfo"))
      this.getCurrentUserDept(currentUserInfo)
      this.selectMyProjectList(currentUserInfo)
    }
  },
  methods: {
    // 校验开票金额和金额明细之和
    validateAmountSum() {
      const kpje = parseFloat(this.formData.kpje);
      const totalAmount = parseFloat(this.formData.totalAmount)

      if (Math.abs(totalAmount - kpje) > 0.01) {
        this.$toast('开票金额与明细金额不一致，请检查！');
        throw new Error('金额校验失败');
      }
    },
    calculateTotalAmount() {
      let total = 0;
      this.formData.kpxxb.forEach(item => {
        if (item.amount) {
          total += parseFloat(item.amount);
        }
      });
      this.formData.totalAmount = total.toFixed(2);
    },
    kjnrSubmit(item, index) {
      item.itemName = this.$refs[`kjnrPicker_${index}`][0].getValues()[0];
      this.popupHidden(this.kjnr.show, index)
    },
    removeItem(index, field) {
      if (this.formData[field].length === 1 && field !== 'relativeFlow') return this.$toast('请至少保留一项')
      this.$dialog.confirm({
        message: '确定删除该项吗？',
      }).then(() => {
        this.formData[field].splice(index, 1)
      })
    },
    addKpItem() {
      this.formData.kpxxb.push(JSON.parse(JSON.stringify(kpItem)))
    },
    calculateAmount(item) {
      if (item.num && item.price) {
        const amount = parseFloat(item.num) * parseFloat(item.price);
        item.amount = amount.toFixed(2);
      }
      this.calculateTotalAmount()
    },
    formatToTwoDecimals,
    init() {
      // 获取部门用户树
      this.getDeptUserTreeAll()
      // 抬头 ticket_head_type
      getDictDataByType('ticket_head_type').then(res => {
        const data = res.data.map(item => {
          return item.dictLabel
        })
        this.ttlx.data = data
        this.ttlx.filteredData = data
      })
      // 开票类型 ticket_type
      getDictDataByType('ticket_type').then(res => {
        const data = res.data.map(item => {
          return item.dictLabel
        })
        this.kplx.data = data
        this.kplx.filteredData = data
      })
      // 交付方式 ticket_way
      getDictDataByType('ticket_way').then(res => {
        const data = res.data.map(item => {
          return item.dictLabel
        })
        this.fpjffs.data = data
        this.fpjffs.filteredData = data
      })
      // 开具内容 ticket_content
      getDictDataByType('ticket_content').then(res => {
        const data = res.data.map(item => {
          return item.dictLabel
        })
        this.kjnr.data = data
        this.kjnr.filteredData = data
      })
      this.fmInvoiceList()
    },
    kjnrTabClick(item) {
      // 拼接，逗号分隔
      if (this.formData.kjnr.indexOf(item) === -1) {
        this.formData.kjnr += ',' + item
      }
      // 去除首位逗号
      this.formData.kjnr = this.formData.kjnr.replace(/^,|,$/g, '')
    },
    kprqConfirm(date) {
      this.formData.kprq = moment(date).format('YYYY-MM-DD')
      this.kprq.show = false
    },
    uploadSuccess(fileList) { // 每次都会filelist全部丢出来
      this.formData.fj = fileList
    },
    contractFinish(item) {
      if (!item || item.length === 0) return;
      this.htmc.show = false;
      this.formData.ssxm = item[0].projectId + ',' + item[0].projectName
      this.formData.htmc = item[0].contractId + ',' + item[0].contractName
      this.formData.khmc = item[0].customerCompanyName
      this.formData.htje = item[0].contractAmount
      this.formData.kptt = item[0].invoiceTitle
      this.formData.nsrsbh = item[0].invoiceNo
      this.formData.khh = item[0].invoiceBank
      this.formData.khzh = item[0].invoiceAccount
      getInvoiceAmount({contractId: item[0].contractId}).then(res => {
        if (res.data) {
          this.formData.ykpje = res.data
        } else {
          this.formData.ykpje = 0.00
        }

      })
    },
    // 子公司列表
    fmInvoiceList() {
      fmInvoiceList().then(res => {
        this.fpkjdw.filteredData = res.data.map(item => {
          return {
            label: item.unitName,
            value: item.unitName
          }
        })
        this.fpkjdw.data = res.data.map(item => {
          return {
            label: item.unitName,
            value: item.unitName
          }
        })
      })
    },
    // 获取人员所属部门列表
    getCurrentUserDept(user) {
      return new Promise(resolve => {
        getCurrentUserDept({userId: user.id || user.userId}).then(res => {
          this.ssbm.data = res.data
          // 搜索过滤
          this.ssbm.filteredData = this.ssbm.data
          resolve(res.data)
        })
      })
    },
    // 获取人员所属项目列表
    selectMyProjectList(user) {
      return new Promise(resolve => {
        selectMyProjectList({projectMember: user.id || user.userId}).then(res => {
          this.ssxm.data = res.rows
          this.ssxm.filteredData = res.rows
          resolve(res.rows)
        })
      })
    },
    // 人员、部门树
    getDeptUserTreeAll() {
      const _this = this
      getDeptUserTreeAll().then(res => {
        // 递归处理this.deptUserTreeAll，添加禁用状态和uuid
        const data = this._getDeptUserTreeAll(res.data[0].children)
        this.$nextTick(() => {
          this.$set(this.deptUserTreeAll, 'data', data)
          this.$set(this.approver, 'data', data)
        })
      })
    },
  }
}
</script>
